<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">
            {{ $t('dashboard.dashboard_for') + piniaUserStore().currentUser?.user?.userAccessRightsTranslation }}
          </h6>

          <Menu/>

          <div class="element-box mt-5">
            <h5 class="form-header mb-4">
              Standortinformationen
            </h5>

            <div class="row">
              <div class="col-lg-2 col-md-4 col-sm-12">
                <SelectVue
                    :placeholder="$t('general.year')"
                    v-model="filters.year"
                    :options="dropdownYears"
                    :is-clear="false"
                />
              </div>
              <div class="col-lg-2 col-md-5 col-sm-12">
                <SelectVue
                    v-model="filters.month"
                    :placeholder="$t('general.month')"
                    :options="monthsInYear || []"
                    :is-clear="false"
                />
              </div>
              <div class="col-md-3">
                <SelectVue
                    :placeholder="$t('general.locations')"
                    v-model="filters.locationId"
                    :options="dropdownOffices"
                    :is-clear="true"
                />
              </div>
              <div class="col-auto text-center">
                <button class="btn btn-primary custom_search_button2" @click="getUnitsDone(1)">
                      <span v-if="isSearching">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{ $t('general.button.search_in_progress') }}
                      </span>
                  <span v-else>
                        {{ $t('general.button.search') }}
                      </span>
                </button>
              </div>
            </div>
            <div class="table-responsive overflow-auto mt-3">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>
                    {{ $t('general.location') }}
                  </th>
                  <th class="text-right" style="width: 20%">
                    unterschriebene Einheiten
                  </th>
                  <th class="text-right" style="width: 22%">
                    Einheiten ohne Unterschrift
                  </th>
                  <th></th>
                  <th class="text-right" style="width: 15%">
                    gesamt
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data of unitsDoneData.data" v-bind:key="data?.name">
                  <td class="text-left">
                    <strong class="js-lists-values-employee-name">{{ data?.name }}</strong>
                  </td>
                  <td class="text-right">
                    <strong class="js-lists-values-employee-name">{{ data?.signedUnits }}</strong>
                  </td>
                  <td class="text-right">
                    <strong class="js-lists-values-employee-name">{{ data?.unsignedUnits }}</strong>
                  </td>
                  <td>
                    <div @click="() => navigateToPage(data)">
                      <div class="os-icon os-icon-list font-weight-bolder text-primary cursor-pointer"
                           style="font-size: 18px;"></div>
                    </div>
                  </td>
                  <td class="text-right">
                    <strong class="js-lists-values-employee-name">{{ data?.totalUnits }}</strong>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <Pagination
              v-if="unitsDoneData?.pagination?.total_pages > 1"
              :totalPages="unitsDoneData?.pagination?.total_pages"
              :currentPage="unitsDoneData?.pagination?.current_page"
              @pagechanged="getUnitsDone"
          />

        </div>
      </div>
      <!--      <FormSidebar>-->
      <!--        <template #top>-->
      <!--          <h6 class="element-header">-->
      <!--            Sidebar-->
      <!--          </h6>-->
      <!--        </template>-->

      <!--      </FormSidebar>-->
    </div>
  </div>
</template>

<script setup>
import dashboardHeadPsychosocialServicesService from '@/api/Dashboard/HeadPsychosocialServices';
import FormSidebar from '@/components/FormSidebar.vue';
import Pagination from '@/components/Pagination.vue';
import SelectVue from '@/components/SelectVue.vue';
import { ErrorToast } from '@/components/VueToast';
import { getOfficeByUserRoleDropdown, getYears } from '@/shared/dropdowns';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import { piniaFilterStore } from '@/store/piniaFilterStore';
import { piniaUserStore } from '@/store/piniaUserStore';
import Menu from '@/views/App/Dashboard/HeadPsychosocialServices/Menu.vue';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

const filtersStore                                    = piniaFilterStore();
const router                                          = useRouter();
const { enums }                                       = piniaEnumsStore();
const { monthsInYear } = computed(() => enums).value;

const currentDate = new Date();

const unitsDoneData = ref({});
const filters       = ref({
  year: currentDate.getFullYear(),
  month: currentDate.getMonth() + 1,
});

const filtersSent   = ref({});

const dropdownOffices      = ref([]);
const dropdownYears        = ref([]);
const dropdownCoachingType = ref([]);
const isSearching          = ref(false);

async function getUnitsDone(page = 1) {
  try {
    isSearching.value   = true;
    const { data }      = await dashboardHeadPsychosocialServicesService.getUnitsDonePerLocation({
      ...filters.value,
      page,
    });
    unitsDoneData.value = data;
    filtersSent.value   = filters.value;
    isSearching.value   = false;
  } catch (error) {
    isSearching.value = false;
    await ErrorToast(error);
  }
}

const navigateToPage = (user) => {
  filtersStore.setLocationData({ ...filtersSent.value, locationId: user?.id });
  router.push({ name: 'dashboardHeadPsychosocialServicesUnsignedUnitsLocation', params: { locationId: user?.id } });
};

onMounted(async () => {
  filtersStore.setLocationData({});
  await Promise.all([
    getUnitsDone(),
    getYears(dropdownYears),
    getOfficeByUserRoleDropdown(dropdownOffices),
  ]);
});

</script>

<style scoped>

::v-deep(.apexcharts-legend) {
  display: block !important;
}

</style>